export const hasParentWithMatchingSelector = (
  target: Element,
  selector: string,
): boolean => {
  return Array.from(document.querySelectorAll(selector)).some(
    (el) => el !== target && el.contains(target),
  );
};
